import React from "react";

/**
 * KeyValueRow — small definition-list row (used in detail panels).
 *
 *  - label: short uppercase label
 *  - value: ReactNode
 *  - inline: render label/value on the same line (default true)
 *  - testId
 */
export function KeyValueRow({ label, value, inline = true, className = "", testId }) {
  if (inline) {
    return (
      <div data-testid={testId} className={`flex items-start gap-3 py-1.5 ${className}`}>
        <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 w-36 shrink-0 pt-0.5">
          {label}
        </span>
        <span className="flex-1 text-sm">{value ?? <span className="text-zinc-400">—</span>}</span>
      </div>
    );
  }
  return (
    <div data-testid={testId} className={`py-1.5 ${className}`}>
      <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="mt-0.5 text-sm">{value ?? <span className="text-zinc-400">—</span>}</div>
    </div>
  );
}
